import { useEffect, useMemo, useState } from "react";
import {
  partitionBusinessNetworkEvents,
  subscribeToBusinessNetworkEvents,
} from "./businessNetworkEvents";

export default function useBusinessNetworkEvents(now = null) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const [clock, setClock] = useState(() => now || new Date());

  useEffect(() => {
    if (now) {
      setClock(now);
      return undefined;
    }
    const timer = window.setInterval(() => setClock(new Date()), 60 * 1000);
    return () => window.clearInterval(timer);
  }, [now]);

  useEffect(() => {
    setLoading(true);
    setError("");
    return subscribeToBusinessNetworkEvents(
      (records) => {
        setEvents(records);
        setLoading(false);
        setError("");
      },
      (loadError) => {
        console.error("Unable to load Business Network events", loadError);
        setLoading(false);
        setError("Business Network event information is temporarily unavailable.");
      }
    );
  }, [attempt]);

  const partition = useMemo(
    () => partitionBusinessNetworkEvents(events, clock),
    [clock, events]
  );

  return {
    events,
    ...partition,
    loading,
    error,
    retry: () => setAttempt((value) => value + 1),
  };
}
